// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonObjectCreate/style.css
// module id = 3770
// module chunks = 33